const doc = [({"en":({"adminConstantHotelPlanBookingStatus":({"booked":"Booking Confirmation", "requested":"Booking Request"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;